<template>
    <el-dialog
        :title="(isForm ? (formId ? '编辑' : '选择关联菜单') : '查看') + dialogTitle"
        width="640px"
        :model-value="modelValue"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form ref="formRef" :model="formData" label-width="120px" style="max-width: 540px">
            <el-row>
                <el-col :span="6">
                    <div class="module-box">
                        <h4>
                            <el-icon>
                                <Expand />
                            </el-icon>
                            模块筛选
                        </h4>
                        <ul class="module-item" v-for="item in moduleOptionLists" :key="item.id" @click="changeMoudle(item.id)">
                            <li :class="item.id == currentModule ? 'active' : ''" :title="item.name">{{ item.name }}</li>
                        </ul>
                    </div>
                </el-col>
                <el-col :span="18">
                    <el-scrollbar v-if="isForm" style="height: 520px; overflow: auto; width: 100%">
                        <el-form-item>
                            <el-radio-group v-model="formData.auth">
                                <el-radio v-for="(item, index) in authListsData" :key="index" :value="item.value">
                                    {{ item.label }} ({{ item.perms }})
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-scrollbar>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref, watch } from 'vue'
import { getModuleOptionLists } from '@/api/module'
import { getAuthOptionLists } from '@/api/auth'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    formId: {
        type: String,
        required: false
    },
    selectId: {
        type: String,
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源
const formData = ref({
    auth: props.selectId
})
// 验证规则

const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)
const currentModule = ref('')
const moduleOptionLists = ref([])
const moduleOptionObj = ref({})
const modList = ref([])
const currentClickMoudleId = ref(null)
const authListsData = ref([])
const getList = async () => {
    await getModuleListData()
    getAuthListsData()
}
const getModuleListData = async () => {
    const data = await getModuleOptionLists()
    modList.value = data
    currentClickMoudleId.value = data?.[0]?.id
}
// 获取数据的方法
const getModuleOptionListsData = async () => {
    const moduleOptionRes = await getModuleOptionLists({})
    moduleOptionLists.value = moduleOptionRes
    currentModule.value = moduleOptionRes[0].id
    getList()
    const optionObj = {}
    moduleOptionRes.forEach((item) => {
        optionObj[item.id] = item.name
    })
    moduleOptionObj.value = optionObj
}
const changeMoudle = (id) => {
    currentModule.value = id
    getList()
}

/**
 * 关闭
 */
const closed = () => {
    dialogTitle.value = ''
    emits('update:modelValue', false)
    formRef.value.resetFields()
}

/**
  确定按钮点击事件
 */

const onConfirm = async () => {
    if (!props.isForm) return
    authListsData.value.forEach((moduleName) => {
        if (moduleName.value === formData.value.auth) {
            const selectName = moduleName.label
            console.log(selectName, 'selectName')
            emits('updateForm', moduleName)
        }
    })
    closed()
}

// 获取菜单权限详情
const getAuthListsData = async () => {
    const data = await getAuthOptionLists({
        auth_type: 2,
        mod: currentModule.value
    })
    const result = data.map((v) => ({ value: v.id, label: v.name, perms: v.perms }))
    authListsData.value = result
}
// 只有formId有的时候，才会去请求数据
watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal && props.formId) {
            getAuthListsData()
        } else {
            formData.value = {
                auth: props.selectId
            }
        }
    }
)
onMounted(() => {
    getModuleOptionListsData()
})
</script>

<style lang="scss" scoped>
.hover-class {
    display: flex !important;
    justify-content: center !important;
    color: var(--theme-color) !important;
    cursor: pointer;
}

.el-table_1_column_2 {
    width: 400px !important;
}

.el-table_1_column_3 {
    width: 400px !important;
}

.dot {
    box-shadow: none !important;
    align-items: center;
}

.card-headers {
    display: flex;
    align-items: center;

    .circlePlusFilled {
        flex: 1;
        margin-left: 30px;
    }
}

.li-item {
    align-items: center;
    display: flex;
    justify-content: space-between;
    overflow-x: auto;
}

.ellipsis {
    color: var(--theme-color);
    font-size: 16px;
}

.ellipsis:focus-visible {
    outline: none;
}

.auth-container {
    display: flex;
    height: 790px;

    .module-box {
        width: 200px;
        background-color: #fafcfe;
        height: 520px;
        padding: 5px 0;
        box-sizing: border-box;
        font-size: 14px;
        overflow-y: auto;

        h4 {
            padding: 10px 10px;
            line-height: 28px;
            font-weight: normal;
            color: #7c7e82;
            font-size: 14px;
            display: flex;
            align-items: center;
        }

        li {
            padding: 12px 20px;
            cursor: pointer;
            position: relative;
            color: #232323;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:hover {
                background-color: var(--el-color-primary-light-9);
            }
        }

        .active {
            background-color: var(--el-color-primary-light-9);

            &::after {
                position: absolute;
                right: -1px;
                top: 0;
                content: '';
                width: 2px;
                height: 100%;
                background-color: #4291f7;
            }
        }

        .cell {
            width: 250px !important;
        }
    }

    .el-card {
        width: calc(100% - 150px);
        overflow-y: auto;
    }
}
</style>
